type EscrowMetrics = {
  totalEscrowsCreated: number;
  successfulExchanges: number;
  failedExchanges: number;
};

const getEscrowMetrics = async (): Promise<EscrowMetrics> => {
  const response = await fetch(
    `${import.meta.env.VITE_API_URL}/metrics/escrow`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    },
  );
  if (!response.ok) {
    throw new Error("Error fetching escrow metrics");
  }

  const data = (await response.json()) as EscrowMetrics;

  return data;
};

export { getEscrowMetrics };
export type { EscrowMetrics };
